import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface TheadProps {
  children?: ReactNode;
}

export const Thead = styled.thead<TheadProps>``;

interface TrProps {
  borderBottom?: boolean;
  children?: ReactNode;
}

export const Tr = styled.tr<TrProps>`
  background: ${({ theme }) => theme.palette.backgrounds.columnHeader};
  padding: 0 25px;
  width: fit-content;

  ${({ borderBottom, theme }) =>
    borderBottom &&
    css`
      border-bottom: ${`1px solid ${theme.palette.tableBorderColor}`};
    `}
`;

interface ThProps {
  lines?: number;
  textAlign?: string;
  children?: ReactNode;
}

export const Th = styled.th<ThProps>`
  border-bottom: none;
  font:
    400 12px/1.2em 'Open Sans',
    sans-serif;
  letter-spacing: 0.02em;
  padding: ${({ lines }) => (lines == 2 ? 12 : 25)}px 15px;
  text-align: ${({ textAlign }) => textAlign};
  text-transform: uppercase;
  vertical-align: top;
  height: 50px;
  min-width: 130px;
`;
